import type { ReactNode, RefObject } from 'react';

import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuTrigger,
} from '@nesso/ui/primitives/dropdown-menu';

const RESULT_ROW_HEIGHT_PX = 40;
const RESULT_LIST_OFFSET_PX = 16;

type SearchComboboxResultsProps = {
    id: string;
    isOpen: boolean;
    maxVisibleRows: number;
    onOpenChange: (open: boolean) => void;
    rows: ReactNode;
    children: ReactNode;
    inputRef: RefObject<HTMLInputElement | null>;
    onEscape: () => void;
};

export function SearchComboboxResults({
    id,
    isOpen,
    maxVisibleRows,
    onOpenChange,
    rows,
    children,
    inputRef,
    onEscape,
}: SearchComboboxResultsProps) {
    const handleKeyDownCapture = (e: React.KeyboardEvent) => {
        if (e.key === ' ') {
            e.stopPropagation();
        }
    };

    return (
        <DropdownMenu modal={false} open={isOpen} onOpenChange={onOpenChange}>
            <DropdownMenuTrigger asChild>
                <div onKeyDownCapture={handleKeyDownCapture} className="w-full" tabIndex={-1}>
                    {children}
                </div>
            </DropdownMenuTrigger>
            <DropdownMenuContent
                id={id}
                align="start"
                sideOffset={4}
                style={{
                    maxHeight: `min(${maxVisibleRows * RESULT_ROW_HEIGHT_PX + RESULT_LIST_OFFSET_PX}px, var(--radix-dropdown-menu-content-available-height))`,
                }}
                className="p-2"
                onOpenAutoFocus={(e) => e.preventDefault()}
                onCloseAutoFocus={(e) => e.preventDefault()}
                onEscapeKeyDown={onEscape}
                onPointerDownOutside={(e) => {
                    if (inputRef.current?.contains(e.target as Node)) {
                        e.preventDefault();
                    }
                }}
                onFocusOutside={(e) => {
                    if (inputRef.current?.contains(e.target as Node)) {
                        e.preventDefault();
                    }
                }}
                onInteractOutside={(e) => {
                    if (inputRef.current?.contains(e.target as Node)) {
                        e.preventDefault();
                    }
                }}
            >
                {rows}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
